module.exports = __webpack_public_path__ + "static/media/008-lebanon.fc50ca32.svg";